

export default class CurssList {
  constructor(candidates, list) {
    this.candidates = candidates
    this.list = list
  }

  getList() {
    let list = {...this.list}
    if(!list) return {}
    this.candidates.forEach(candidate => {
      let group = candidate.reservedExam.location + '-' + candidate.reservedExam.date
      candidate.group = group
      if(group in list) {
        list[group].items.push(candidate)
      }
      else {
        list[group] = {
          label: `${candidate.reservedExam.date} ${candidate.reservedExam.location}`,
          items: [candidate]
        }
      }
    })

    return list
  }
}